var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay",class:[_vm.getPosition, { 'overlay-search-results': _vm.overlay === 'search-results' }],attrs:{"role":"status"}},[_c('md-progress-spinner',{attrs:{"md-mode":"indeterminate","md-stroke":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }